// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__328mo","right":"styles_right__lZrfh"};